// extracted by mini-css-extract-plugin
export default {"header":"PlaceDetails_header__hu1g7","container":"PlaceDetails_container__8+Jos","image":"PlaceDetails_image__zyw8Z"};